/**
 * 开户方案 A：仅规范 6 个 step_code 打 kyc_step_view / complete。
 * 注意：不 import store，避免与 store 循环依赖；isMainland 由调用方传入。
 */

import {
  trackKycStepComplete,
  trackKycStepView,
  type KycStepCode
} from '../../../../analytics'

/** 大陆无活体视频步；签名 / 提交相对旧表（含视频）各 -1 */
const MAINLAND_STEP_MAP: Record<number, KycStepCode> = {
  2: 'identity_select',
  3: 'id_upload',
  13: 'risk',
  16: 'signature',
  20: 'submit'
}

/** 非大陆无银联页、无活体视频步 */
const NON_MAINLAND_STEP_MAP: Record<number, KycStepCode> = {
  2: 'identity_select',
  3: 'id_upload',
  12: 'risk',
  15: 'signature',
  19: 'submit'
}

let activeStepCode: KycStepCode | null = null
let stepEnteredAt = 0

export function resolveKycStepCode(current: number, isMainland: boolean): KycStepCode | null {
  const map = isMainland ? MAINLAND_STEP_MAP : NON_MAINLAND_STEP_MAP
  return map[current] ?? null
}

function enterStep(stepCode: KycStepCode | null): void {
  activeStepCode = stepCode
  stepEnteredAt = Date.now()
  if (stepCode) {
    trackKycStepView({ step_code: stepCode })
  }
}

/** 前进离开某规范步时打 complete；后退不打 complete */
export function completeKycStep(stepCode: KycStepCode, isSuccess: boolean): void {
  const spend = stepEnteredAt > 0 ? Date.now() - stepEnteredAt : 0
  trackKycStepComplete({
    step_code: stepCode,
    spend_time_ms: spend,
    is_success: isSuccess
  })
  if (activeStepCode === stepCode) {
    activeStepCode = null
    stepEnteredAt = 0
  }
}

/**
 * 步号变更通知。
 * @param completePrev 为 true 时，若 prev 落在 6 码内则打 complete(success)
 */
export function notifyKycStepChange(
  prevStep: number,
  nextStep: number,
  isMainland: boolean,
  options?: { completePrev?: boolean }
): void {
  if (prevStep === nextStep) return
  const prevCode = resolveKycStepCode(prevStep, isMainland)
  const nextCode = resolveKycStepCode(nextStep, isMainland)

  if (options?.completePrev && prevCode) {
    // submit 的 complete 由 submitApply 成功处单独打，避免提前 complete
    if (prevCode !== 'submit') {
      completeKycStep(prevCode, true)
    }
  }

  if (nextCode !== activeStepCode) {
    enterStep(nextCode)
  }
}

/** 冷启动 / 恢复进度落到某步时只打 view */
export function syncKycStepView(step: number, isMainland: boolean): void {
  const code = resolveKycStepCode(step, isMainland)
  if (code !== activeStepCode) {
    enterStep(code)
  }
}

/** submitApply 成功后补 submit 步 complete */
export function completeKycSubmitStep(isSuccess: boolean): void {
  const code: KycStepCode = 'submit'
  if (activeStepCode !== 'submit') {
    enterStep(code)
  }
  completeKycStep(code, isSuccess)
}
